import { Box, VStack } from '@chakra-ui/react';
import { getAvatarImage } from 'app/utils/utils';
import { ProfileImageSize } from 'types/enums';
import { Collaborator } from 'types/collaborator.types';
import { ChakraAvatar } from 'app/components/Core';
import { avatarSimpleBgSx, bgImageContainerSx, bgImageSx } from './styles';

const BLUR_RATIO = 256;
const OPACITY_RATIO = 0.8;

interface BackgroundImageProps {
  collaborator: Pick<Collaborator, 'profile' | 'profileCard'>;
}

export const BackgroundImage = ({ collaborator }: BackgroundImageProps) => {
  const avatarUrl = getAvatarImage(
    collaborator.profile?.profileImages,
    ProfileImageSize.AVATAR_SMALL
  );

  return (
    <VStack alignItems="center" position="relative" p={6} spacing={0}>
      {avatarUrl ? (
        <Box sx={bgImageContainerSx} overflow="hidden" rounded={4}>
          <Box
            sx={bgImageSx}
            backgroundImage={avatarUrl}
            filter={`blur(${BLUR_RATIO}px)`}
          />
          <Box
            bg={collaborator.profileCard?.avatarColors?.text}
            opacity={OPACITY_RATIO}
          />
        </Box>
      ) : (
        <Box
          rounded={4}
          sx={avatarSimpleBgSx}
          bg={collaborator.profileCard?.avatarColors?.text}
        />
      )}
      <ChakraAvatar
        size="2xl"
        src={avatarUrl}
        initials={collaborator.profile?.initials}
        colors={collaborator.profileCard?.avatarColors}
      />
    </VStack>
  );
};
